import BackPageButton from "components/buttons/BackPageButton";
import { Outlet } from "react-router-dom";
import ROUTES from "constants/routes";

const ExaminationLayout = () => {
  return (
    <>
      <BackPageButton
        defaultValue={{
          text: `Список тестирований`,
          link: `/${ROUTES.TESTING}`,
        }}
      />
      <Outlet />
    </>
  );
};

export default ExaminationLayout;
